import { faCircleCheck } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

export const SuccessView = () => {
  return (
    <div
      className="vai-flex vai-items-start vai-gap-4 vai-py-2"
      data-testid="feedback-success-view"
    >
      {/* Green check icon */}
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="vai-text-green-500 vai-text-3xl vai-flex-shrink-0 vai-mt-1"
      />

      {/* Content */}
      <div className="vai-flex vai-flex-col vai-gap-2">
        <h2 className="vai-text-xl vai-font-semibold vai-text-gray-900">
          <Trans>Feedback sent</Trans>
        </h2>
        <p className="vai-text-sm vai-text-gray-600">
          <Trans>Thanks for helping us improve the product.</Trans>
        </p>
      </div>
    </div>
  );
};
